<div class="unauthorized-header">
  <div class="logo-container">
    <img src="../assets/images/logo.png" alt="NCSEAA K12 Scholarships" class="logo" />
  </div>
</div>

<div class="unauthorized-page">
  <div class="unauthorized-container">
    <div class="unauthorized-content">
      <h1 class="title">K12 Schools</h1>
      <h2 class="subtitle">Access Denied</h2>
      <p class="message">You do not have access to the Schools application.</p>
      <p class="help-text">
        The signed in user is blocked because they are not a direct member of a group with access,
        nor had access directly assigned by an administrator.
      </p>
      <p class="contact">Please contact your administrator to assign access to this application.</p>
    </div>
  </div>
</div>
